<template>
	<div class="section2">
		<div class="count-section">
			<div class="top-1">
				<span class="column">
					<span class="title">{{ $t('使用人数') }}</span>
					<span class="value">
						<span>{{ aiData.count || 0 }}</span>
					</span>
				</span>
				<span class="column bl">
					<span class="title">{{ $t('累计赚取') }}</span>
					<span class="value">{{ aiData.count || '0.00' }}</span>
				</span>
			</div>
			<div class="top-2">
				<ul class="ul">
					<li class="row" v-for="item in aiData.product_list" :key="item.id">
						<span class="column">
							<span>
								<img alt="" :src="item.image" class="lazy-img">{{ item.symbol }}</span>
							<span>{{ Number(item.price) }}</span>
						</span>
					</li>
				</ul>
			</div>
		</div>
		<div class="count-section wrap2" v-if="userOrder">
			<div class="cm-card-title">
				<span class="text fade-in-right">{{ $t('正在运行') }}</span>
			</div>
			<div class="stack">
				<div class="row">
					<span class="f18">{{ userOrder.name }}</span>
					<span class="title">{{ $t('当前收益') }}</span>
				</div>
				<div class="row">
					<span class="title">{{ userOrder.type }}{{ $t('预测') }}</span>
					<span class="f18 win">{{ userOrder.current_profit }}₮</span>
				</div>
				<div class="row-2">
					<div class="box">
						<img alt="" src="@/assets/img-pc/61.0ab9a4e5.svg">
						<span>{{ $t('正在运行....') }}</span>
						<img src="https://api.shengge975.com/upload/1716105174584643.png" class="coin">
						<img src="https://api.shengge975.com/upload/1745203113522226.png" class="coin">
					</div>
					<div class="schedule">
						<i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
					</div>
				</div>
			</div>
		</div>
		<div class="count-section wrap2 dis-fle ali-cen jus-cen" v-else>
			<svg data-v-26ff9a52="" width="66" height="50" viewBox="0 0 66 50" fill="none"
				xmlns="http://www.w3.org/2000/svg" class="svg-class">
				<path data-v-26ff9a52=""
					d="M7.33936 7.80139H46.3551V24.4C46.3551 33.3608 46.3551 37.8412 44.6112 41.2638C43.0773 44.2744 40.6296 46.7221 37.619 48.2561C34.1964 50 29.716 50 20.7551 50H13.7394C11.4991 50 10.379 50 9.52339 49.564C8.77075 49.1805 8.15882 48.5686 7.77533 47.8159C7.33936 46.9603 7.33936 45.8402 7.33936 43.6V7.80139Z"
					fill="white" fill-opacity="0.04"></path>
				<path data-v-26ff9a52=""
					d="M7.8014 49.9995C3.4928 49.9995 0 46.5067 0 42.1981H33.0283C33.0283 49.9995 40.3679 49.9995 40.3679 49.9995H7.8014Z"
					fill="url(#paint0_linear_863_39965)"></path>
				<path data-v-26ff9a52=""
					d="M15.1408 -2.6226e-05C10.8322 -2.6226e-05 7.33936 3.49279 7.33936 7.80139H46.3552C46.3552 -2.6226e-05 53.6948 -2.6226e-05 53.6948 -2.6226e-05H15.1408Z"
					fill="url(#paint1_linear_863_39965)"></path>
				<rect data-v-26ff9a52="" x="13.2173" y="13.3334" width="17.7606" height="2.5" rx="1.25" fill="white"
					fill-opacity="0.06"></rect>
				<rect data-v-26ff9a52="" x="13.2173" y="22.0833" width="12.3911" height="2.50001" rx="1.25" fill="white"
					fill-opacity="0.06"></rect>
				<rect data-v-26ff9a52="" x="13.2173" y="30.8333" width="16.5215" height="2.50001" rx="1.25" fill="white"
					fill-opacity="0.06"></rect>
				<path data-v-26ff9a52="" fill-rule="evenodd" clip-rule="evenodd"
					d="M59.5244 29.0085C59.5244 34.755 54.9639 39.4135 49.3384 39.4135C43.7128 39.4135 39.1523 34.755 39.1523 29.0085C39.1523 23.262 43.7128 18.6035 49.3384 18.6035C54.9639 18.6035 59.5244 23.262 59.5244 29.0085ZM55.8508 29.1791C55.8508 32.9473 52.8603 36.002 49.1714 36.002C45.4825 36.002 42.4921 32.9473 42.4921 29.1791C42.4921 25.4109 45.4825 22.3562 49.1714 22.3562C52.8603 22.3562 55.8508 25.4109 55.8508 29.1791Z"
					fill="#7A7A97"></path>
				<path data-v-26ff9a52=""
					d="M49.1715 36.0021C52.8605 36.0021 55.8509 32.9473 55.8509 29.1791C55.8509 25.4109 52.8605 22.3562 49.1715 22.3562C45.4826 22.3562 42.4922 25.4109 42.4922 29.1791C42.4922 32.9473 45.4826 36.0021 49.1715 36.0021Z"
					fill="#00A609" fill-opacity="0.1"></path>
				<path data-v-26ff9a52="" fill-rule="evenodd" clip-rule="evenodd"
					d="M59.3054 39.7336L56.4507 36.7375L57.255 35.9489L60.1098 38.945L59.3054 39.7336Z" fill="#7A7A97">
				</path>
				<path data-v-26ff9a52="" fill-rule="evenodd" clip-rule="evenodd"
					d="M61.8237 39.0827C61.5076 38.7598 61.0934 38.5984 60.6792 38.5984C60.2649 38.5984 59.8507 38.7598 59.5346 39.0827C59.2186 39.4055 59.0605 39.8286 59.0605 40.2518C59.0605 40.6749 59.2186 41.0981 59.5346 41.4209L63.2368 45.2026C63.5528 45.5255 63.967 45.6869 64.3813 45.6869C64.7955 45.6869 65.2098 45.5255 65.5258 45.2026C65.8419 44.8798 65.9999 44.4567 65.9999 44.0335C65.9999 43.6104 65.8419 43.1872 65.5258 42.8644L61.8237 39.0827Z"
					fill="#7A7A97"></path>
				<defs data-v-26ff9a52="">
					<linearGradient data-v-26ff9a52="" id="paint0_linear_863_39965" x1="22.6228" y1="42.1981"
						x2="22.6228" y2="49.9995" gradientUnits="userSpaceOnUse">
						<stop data-v-26ff9a52="" stop-color="white" stop-opacity="0.08"></stop>
						<stop data-v-26ff9a52="" offset="1" stop-color="white" stop-opacity="0.04"></stop>
					</linearGradient>
					<linearGradient data-v-26ff9a52="" id="paint1_linear_863_39965" x1="33.3177" y1="7.80139"
						x2="33.3177" y2="-2.6226e-05" gradientUnits="userSpaceOnUse">
						<stop data-v-26ff9a52="" stop-color="white" stop-opacity="0.04"></stop>
						<stop data-v-26ff9a52="" offset="1" stop-color="white" stop-opacity="0.08"></stop>
					</linearGradient>
				</defs>
			</svg>
		</div>
		<div class="count-section wrap3">
			<h4>{{ $t('AI策略知识') }}</h4>
			<div v-for="item in aiData.rich_text" :key="item.id" @click="$refs.wtDialogRef.open(item)">
				<span>{{ item.title }}</span>
				<div class="svg-container svg-img" style="fill: rgb(255, 255, 255);">
					<svg width="8" height="8" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg" class="svg-class">
						<g id="ä¸‰è§’å½¢">
							<path id="Vector 1859" d="M7 4L2 0V8L7 4Z"></path>
						</g>
					</svg>
				</div>
			</div>
		</div>

		<wtDialog ref="wtDialogRef"></wtDialog>
	</div>
</template>
<script>
import wtDialog from './wtDialog.vue';
export default {
	components: { wtDialog },
	props: {
		aiData: {
			type: Object,
			default: () => { },
		},
	},
	data() {
		return {};
	},
	computed: {
		userOrder() {
			return this.aiData.user_order || null
		}
	},
	methods: {

	},
};
</script>
<style lang="scss" scoped>
.section2 {
	height: 280px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 12px;
	border-width: 2px;
	border-style: solid;
	border-color: rgb(37, 39, 49);
	border-image: initial;
	background: rgb(18, 20, 30);
	margin: 30px auto;
	padding: 30px 50px;

	.count-section {
		height: 220px;
		background-color: rgb(11, 11, 13);
		flex: 1 1 0%;
		border-radius: 8px;

		.top-1 {
			display: flex;
			flex-wrap: nowrap;
			flex-direction: row;
			align-items: normal;
			justify-content: space-between;
			width: 100%;
			height: 92px;
			border-bottom: 1px dashed rgb(55, 55, 57);

			.column {
				display: flex;
				flex-wrap: nowrap;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				flex: 1 1 0%;
				position: relative;

				.title {
					color: #adadad;
					font-size: 16px;
				}

				.value {
					font-size: 24px;
				}

				&.bl :before {
					content: "";
					position: absolute;
					height: 52px;
					width: 1px;
					border-left: 1px dashed #373739;
					top: 50%;
					left: 0;
					transform: translateY(-50%);
				}
			}
		}

		.top-2 {
			display: flex;
			flex-wrap: nowrap;
			flex-direction: row;
			align-items: normal;
			justify-content: space-between;
			width: 100%;

			ul {
				display: flex;
				justify-content: space-between;
				margin-top: 30px;
				width: 100%;
				padding: 0 30px;
				list-style: none;

				.column {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: column;
					align-items: center;
					justify-content: center;

					span:first-of-type {
						color: #adadad;
						font-size: 14px;
						display: flex;
						margin-bottom: 6px;

						img {
							width: auto;
							height: 20px;
							transform: translateY(-1px);
							margin-right: 3px;
						}
					}

					span:nth-of-type(2) {
						font-size: 20px;
						font-weight: 500;
					}
				}
			}
		}
	}

	.wrap2 {
		margin: 0px 30px;
		padding: 20px 40px;

		.cm-card-title {
			width: 100%;
			height: 24px;
			margin-bottom: 15px;
			padding: 0 12px;
			font-size: 18px;
			color: #00f0ff;
		}

		.stack {
			height: 154px;
			margin: 0 auto;
			display: flex;
			flex-wrap: nowrap;
			flex-direction: column;
			align-items: normal;
			justify-content: normal;
			padding: 20px 16px;
		}

		.row {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 20px;
			line-height: 20px;
			margin-bottom: 10px;
			width: 100%;
			font-size: 16px;

			.win {
				color: #00f0ff;
			}

			.f18 {
				font-size: 18px;
			}
		}

		.row-2 {
			margin-top: 20px;
			position: relative;

			.box {
				display: flex;
				align-items: center;
				justify-content: space-between;

				img {
					width: 30px;
					height: 30px;
					background-color: transparent;

					&.coin {
						margin-left: -10px;
					}
				}

				span {
					margin-right: auto;
					margin-left: 10px;
					font-size: 16px;
				}
			}

			.schedule {
				position: absolute;
				z-index: 1;
				bottom: 0;
				left: 0;
				width: 100%;
				height: 100px;
				padding: 0 40px;
				display: flex;
				align-items: flex-end;
				justify-content: space-between;

				i {
					width: 18px;
					height: 34px;
					border-radius: 6px;
					background-color: #00f0ff;

					/* 设置透明度渐变和动画延迟 */
					&:nth-child(1) {
						opacity: 1;
						animation-delay: 0s;
					}

					&:nth-child(2) {
						opacity: 0.9;
						animation-delay: 0.1s;
					}

					&:nth-child(3) {
						opacity: 0.8;
						animation-delay: 0.2s;
					}

					&:nth-child(4) {
						opacity: 0.7;
						animation-delay: 0.3s;
					}

					&:nth-child(5) {
						opacity: 0.6;
						animation-delay: 0.4s;
					}

					&:nth-child(6) {
						opacity: 0.5;
						animation-delay: 0.5s;
					}

					&:nth-child(7) {
						opacity: 0.4;
						animation-delay: 0.6s;
					}

					&:nth-child(8) {
						opacity: 0.3;
						animation-delay: 0.7s;
					}

					&:nth-child(9) {
						opacity: 0.2;
						animation-delay: 0.8s;
					}

					&:nth-child(10) {
						opacity: 0.1;
						animation-delay: 0.9s;
					}

					animation: fadeLoop 1s linear infinite;
				}
			}

			/* 透明度循环动画 */
			@keyframes fadeLoop {

				0%,
				100% {
					opacity: 0;
				}

				50% {
					opacity: 0.5;
				}
			}

		}
	}

	.wrap3 {
		padding: 20px 50px;
		overflow-y: auto;

		h4 {
			font-size: 18px;
			color: #00f0ff;
			margin: 0px;
		}

		>div {
			height: 40px;
			border-bottom: 1px solid #252731;
			cursor: pointer;
			display: flex;
			flex-wrap: nowrap;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			font-size: 14px;
		}
	}
}
</style>